import { MinusCircleFilled, MinusCircleOutlined, PlusCircleFilled, PlusOutlined } from '@ant-design/icons';
import { Form, Input, Select, Row, Col, Button, Tooltip } from 'antd';
import React, { useEffect, useState } from 'react';

const GilMultiRowAddNew = ({
    label,
    labelCol,
    name,
    form,
    placeholder,
    defaultValue,
    disabled,
    hideLabel,
    required,
    errorMessage
}) => {
    const [rowLength, setRowLength] = useState('1');

    useEffect(() => {
        if (defaultValue) {
            form.setFieldsValue({ [name]: defaultValue });
        }
    }, []);

    const onRowRemove = (currentRow) => {
        //  console.log(rowLength, index + 1);
        let formValues = form.getFieldsValue();
        // form.setFieldsValue({ [`${name}-${rowLength}`]: null })
        for (var i = currentRow; i < rowLength; i++) {
            form.setFieldsValue({ [`${name}-${i}`]: formValues[`${name}-${i + 1}`] })
        };
        form.setFieldsValue({ [`${name}-${rowLength}`]: null })
        setRowLength(rowLength - 1);
    }

    console.log(form.getFieldsValue());

    return (
        <div>

            <>
                {
                    Array.from({ length: parseInt(rowLength) }).map((_, i) => (
                        <Form.Item
                            name={name + `-${i + 1}`}
                            labelCol={{ span: labelCol || 8 }}
                            label={hideLabel ? undefined : label + ` ${i + 1}`}
                            rules={[
                                {
                                    required: required,
                                    message: errorMessage + `-${i + 1}`,
                                },
                            ]}>
                            <Input
                                disabled={disabled}
                                placeholder={placeholder + ` ${i + 1}`}
                                type={"text"}
                                style={{fontWeight: 600, height: 40}}
                                suffix={
                                    (i + 1) === parseInt(rowLength) ?
                                        <Tooltip title="Add New" color="geekblue">
                                            <Button
                                                icon={<PlusCircleFilled />}
                                                disabled={disabled} type="link" onClick={() => setRowLength(parseInt(rowLength) + 1)}>{''}</Button>

                                        </Tooltip>
                                        :
                                        <Tooltip title="Delete" color="geekblue">
                                            <Button
                                                icon={<MinusCircleFilled />}
                                                disabled={disabled} type="link" onClick={() => onRowRemove(i + 1)}>{''}</Button>
                                        </Tooltip>

                                }
                            />
                        </Form.Item>
                    ))
                }
            </>
        </div>
    )
};


export default GilMultiRowAddNew;